const INITIAL_STATE = {
  sourcings: [],
  sourcingObj: null,
  sourcingTransactions: [],
  monthStats: [],
};

const setSourcingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_SOURCINGS":
      return { ...state, sourcings: [...action.payload] };
    case "GET_SINGLE_SOURCING":
      return { ...state, sourcingObj: action.payload };
    case "UPLOAD_SOURCING":
      return { ...state, sourcings: [action.payload, ...state.sourcings] };
    case "UPDATE_SOURCING":
      const filteredSourcingsArray = state.sourcings.filter(
        (sourcing) => sourcing.id !== action.payload.id,
      );
      return {
        ...state,
        sourcings: [...filteredSourcingsArray, action.payload],
        sourcingObj:
          state.sourcingObj && state.sourcingObj.id === action.payload.id
            ? action.payload
            : state.sourcingObj,
      };
    case "DELETE_SOURCING":
      const updatedSourcingsArray = state.sourcings.filter(
        (sourcing) => sourcing.id !== action.payload,
      );
      return { ...state, sourcings: [...updatedSourcingsArray] };
    case "GET_ALL_SOURCING_TRANSACTIONS":
      return { ...state, sourcingTransactions: [...action.payload] };
    case "UPLOAD_SOURCING_TRANSACTION":
      return {
        ...state,
        sourcingTransactions: [action.payload, ...state.sourcingTransactions],
      };
    case "GET_ALL_SOURCING_MONTH_STATS":
      return { ...state, monthStats: [...action.payload] };
    default:
      return { ...state };
  }
};

export default setSourcingReducer;
